import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/fonts/index.css";
import reportWebVitals from "./reportWebVitals";

import App from "./App";

// Backup handler (public/index.html registers the primary one first so CRA overlay is skipped).
window.addEventListener(
  "error",
  (event) => {
    if (
      event.message === "Script error." ||
      event.message === "Uncaught Script error." ||
      (event.filename &&
        (event.filename.includes("widget.ebanqo.io") ||
          event.filename.includes("googletagmanager.com") ||
          event.filename.includes("maps.googleapis.com")))
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const errorMessage =
      event.reason?.message || String(event.reason || "");
    if (
      errorMessage.includes("Script error") ||
      errorMessage.includes("ebanqo") ||
      errorMessage.includes("googleapis")
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );

const rootContainer = document.getElementById("root") as HTMLElement;
let container;

container = document.createElement("div");
container.id = "amazon-chime-sdk-widget-container";
rootContainer.appendChild(container);

const root = ReactDOM.createRoot(rootContainer);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
